import React from 'react'
import { Skeleton } from '../../../content/Skeleton/Skeleton'
import { ArrowIcon } from '../../../templates/Publication/SevenNewsPublication/contextual-link/assets/ArrowIcon'
import {
    StyledCommonwealthGamesWidgetCtaArrow,
    StyledCommonwealthGamesWidgetCtaButton,
    StyledCommonwealthGamesWidgetCtaLink,
    StyledCommonwealthGamesWidgetCtaLoading,
} from './CommonwealthGamesWidgetCta.styled'

export interface CommonwealthGamesWidgetCtaProps {
    label: string
    href?: string
    onClick?: () => void
    loading?: boolean
    colorMode?: 'light' | 'dark'
}

export const CommonwealthGamesWidgetCta: React.FC<
    CommonwealthGamesWidgetCtaProps
> = ({ label, href, onClick, loading = false, colorMode = 'light' }) => {
    if (loading) {
        return (
            <StyledCommonwealthGamesWidgetCtaLoading>
                <Skeleton height={40} dark={colorMode === 'dark'} />
            </StyledCommonwealthGamesWidgetCtaLoading>
        )
    }

    if (href) {
        return (
            <StyledCommonwealthGamesWidgetCtaLink
                href={href}
                colorMode={colorMode}
            >
                {label}
                <StyledCommonwealthGamesWidgetCtaArrow colorMode={colorMode}>
                    <ArrowIcon size={20} />
                </StyledCommonwealthGamesWidgetCtaArrow>
            </StyledCommonwealthGamesWidgetCtaLink>
        )
    }

    return (
        <StyledCommonwealthGamesWidgetCtaButton
            type="button"
            onClick={onClick}
            colorMode={colorMode}
        >
            {label}
            <StyledCommonwealthGamesWidgetCtaArrow colorMode={colorMode}>
                <ArrowIcon size={20} />
            </StyledCommonwealthGamesWidgetCtaArrow>
        </StyledCommonwealthGamesWidgetCtaButton>
    )
}

CommonwealthGamesWidgetCta.displayName = 'CommonwealthGamesWidgetCta'
